let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9A19y")).then(() => parcelRequire('2qxWk'));